import { useLoggedUser } from 'state/user';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import useAuthorization, {
  AuthorizationActions,
} from 'routes/surface/hooks/use-authorization';
import { SurfaceNodeUnion } from 'graphql/types';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';

export interface UseCurrentSurfacePermissions {
  isOwner: boolean;
  isSharedSurfaceReference: boolean;
  isNodeOwner(node: SurfaceNodeUnion): boolean;
  canRepositionAny: boolean;
  canDeleteAny: boolean;
}

export default function useCurrentSurfacePermissions(): UseCurrentSurfacePermissions &
  AuthorizationActions {
  const surface = useCurrentSurface();

  const fetchSurfaceNodesFromCache = useFetchSurfaceNodesFromCache();

  const [loggedUser] = useLoggedUser();

  const actions = useAuthorization(surface);

  const nodes = fetchSurfaceNodesFromCache();

  const isOwner = Boolean(
    loggedUser?.id && surface?.ownedBy && loggedUser?.id === surface?.ownedBy,
  );

  function isNodeOwner(node: SurfaceNodeUnion): boolean {
    return node.ownedBy === loggedUser?.id;
  }

  const canDeleteAny =
    actions.canDeleteSurfaceNode() ||
    nodes.some(actions.canDeleteOwnedSurfaceNode);

  const canRepositionAny =
    actions.canRepositionSurfaceNode() ||
    nodes.some(actions.canRepositionSurfaceNode);

  return {
    isOwner,
    // Todo maybe bulletproof this check with condition if logged user is owner of referenced another user is owner of original
    isSharedSurfaceReference: Boolean(
      surface?.surface?.sharedSurfacesRoot && surface?.isReference,
    ),
    isNodeOwner,
    ...actions,
    canDeleteAny,
    canRepositionAny,
  };
}
